//export const BaseUrl = "https://javohirgroup.uz/api";
export const BaseUrl = "https://lyquimoly2.uz/api2";

export const narxlar = {
  val: true,
  som: true,
  perech: true,
};
